import * as yup from 'yup'

export const vehicleValidation = yup.object().shape({
    companyId: yup.string().required('Harus diisi'),
    noPolisi : yup.string().required('Harus diisi'),
    modelKendaraan : yup.string().required('Harus diisi'),
    tahunPembuatan : yup.number().required('Harus diisi'),
    nomorRangka : yup.string().required('Harus diisi'),
    nomorMesin : yup.string().required('Harus diisi'),
    kepemilikan : yup.string().required('Harus diisi'),
}).required()